import React, {useEffect, useState} from "react";
import './Tags.css';
import {colors} from "../../../../../../../../../shared/colors";
import TagsBadge from "./tags-badge/TagsBadge";
import {getContrastTextColor} from "../../../../../../../../../shared/utils/utils";

const getNumberOfTagsWithRespectToWidth = (width) => {
    if (width >= 1570)
        return 7;
    if (width >= 1538)
        return 6;
    if (width >= 1465)
        return 5;
    if (width >= 1400)
        return 4;
    if (width >= 1311)
        return 3;
    return 2;
}

const TagsCell = (props) => {
    const [maxTags, setMaxTags] = useState(getNumberOfTagsWithRespectToWidth(window.innerWidth));
    const [showAll, setShowAll] = useState(false);

    useEffect(() => {
        window.addEventListener('resize', () => {
            setMaxTags(getNumberOfTagsWithRespectToWidth(window.innerWidth))
        })
    })

    const renderAllTags = props.tags.map((tag, idx) => {
        return (<TagsBadge style={{marginBottom: "10px"}} key={"badge-" + idx} name={tag.label}
                           txtColor={getContrastTextColor(tag.color)} bgColor={tag.color}/>)
    });

    const renderPartOfTheTags = props.tags.slice(0, maxTags).map((tag, idx) => {
        return (<TagsBadge key={"badge-" + idx} name={tag.label} txtColor={getContrastTextColor(tag.color)}
                           bgColor={tag.color}/>)
    })

    const renderTags = () => {
        if (props.tags.length <= maxTags || showAll || props.showAll) {
            return renderAllTags;
        } else {
            return (<React.Fragment>
                {renderPartOfTheTags}
                <span>
                    <TagsBadge name={`+  ${props.tags.length - maxTags}`} txtColor="#fff"
                               bgColor={colors.tertiary.dark}/>
                </span>

            </React.Fragment>);
        }
    }
    return (
        <div onClick={(event) => {
            event.stopPropagation();
            setShowAll(!showAll)
        }} align="left">
            {renderTags()}
        </div>
    )
}
export default TagsCell;
